import styled from 'styled-components';
import Button from 'components/Form/Button';
import colors from 'styles/colors';

const ActionButtonContainer = styled.div`
  // top: 0.7rem;
  position:absolute;
  right:0.5rem;
  opacity: 0.75;
  display: flex;
  align-items: baseline;

`;

interface Action {
    label: string;
    icon: string;
    onClick: () => void;
};

const actionButtonStyles = `
  padding: 0 0.25rem;
  font-size: 1.25rem;
  text-align: center;
  width: 1.5rem;
  height: 1.5rem;
  color: ${colors.textColor};
  background: none;
  box-shadow: none;
  transition: all 0.2s ease-in-out;  
  display: flex;
  align-items: center;
  margin-top:0.5rem;
  &:hover {
    color: ${colors.primary};
    background: ${colors.textColorSecondary};
    box-shadow: none;
  }
`;

const ActionButtons2 = (props: { actions: any }): JSX.Element => {
  const actions = props.actions;
  if (!actions) return (<></>);
  return (
    <ActionButtonContainer>
      { actions.map((action: Action, index: number) => 
        <Button
        size='small1'
          key={`action-${index}`}
          $styles={actionButtonStyles}
          onClick={action.onClick}
          title={action.label}>
            {action.icon}
        </Button>
      )}
    </ActionButtonContainer>
  );
};

export default ActionButtons2;
